<template>
  <div>
    <vs-icon
      icon-pack="material-icons"
      icon="close"
      class="remove_dashboard_item"
      @click="$emit('input')"
    />
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>